import React from 'react';
import { useNeoAuth0 } from "./useNeoAuth0";
import { useEffect } from "react";

const LogoutWithRedirect = (props) => {
    const { user, isAuthenticated, isLoading, logout } = useNeoAuth0();

    useEffect(() => {
        (async () => {
            if (!isLoading) {
                logout({ logoutParams: { returnTo: window.location.origin + "/neocuesheet", federated: true } });
            }
        })();
    }, [isAuthenticated, isLoading]);

    return ("");
}

export default LogoutWithRedirect;